import { type ApiError, getProblem } from "@/shared/api/errors";
import { notify } from "@/shared/components/notify";
import { errorCodeMessageKeys } from "@/shared/i18n/errorCodeMap";
import { logger } from "@/shared/logger/logger";

export function handleMutationError(error: unknown, fallbackKey: string): string | undefined {
  const problem = getProblem(error as ApiError | undefined);
  const code = problem?.code;
  logger.error("mutation_failed", { code, status: problem?.status });
  notify.error((code && errorCodeMessageKeys[code]) ?? fallbackKey);
  return code;
}
